import * as yup from 'yup';

import { FormErrors } from '@blockpulse3/data/shared';
import { phoneField } from '@blockpulse3/web-client/forms';

export const phoneSchema = yup.object({
  phone: phoneField.required(FormErrors.RequiredField),
});
